import { Either } from 'funfix-core';
import { Record } from 'immutable';
export const PENDING_ACCEPT_INSTALL_STATUS = 'PENDING_ACCEPT';
export const IN_PROGRESS_INSTALL_STATUS = 'IN_PROGRESS';
export const COMPLETE_INSTALL_STATUS = 'COMPLETE';
export const makePendingConfirmationInstallStatus = Record({
  type: PENDING_ACCEPT_INSTALL_STATUS
});
export const makeInProgressInstallStatus = Record({
  type: IN_PROGRESS_INSTALL_STATUS
});
export const makeCompleteInstallStatus = Record({
  type: COMPLETE_INSTALL_STATUS,
  result: Either.left('error') // Not really a valid default, but need to provide one
});
export function foldInstallStatus(installStatus, pendingConfirmation, installing, complete) {
  switch (installStatus.type) {
    case PENDING_ACCEPT_INSTALL_STATUS:
      return pendingConfirmation(installStatus);
    case IN_PROGRESS_INSTALL_STATUS:
      return installing(installStatus);
    case COMPLETE_INSTALL_STATUS:
      return complete(installStatus);
    default:
      // Flow compile-time validation that we've handled every discover item
      // prettier-ignore
      installStatus;
      return undefined;
  }
}
export function isInstallStatusLoading(installStatus) {
  return foldInstallStatus(installStatus, () => false, () => true, () => false);
}